import { PartyTypes, AuctionStatuses } from 'vdlib';

const RoleStatusColumnsDefs = {
  [`${PartyTypes.Operator}_${AuctionStatuses.Pending}`]: [
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'Από Αρχείο',
    'Photos',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.Active}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.ForSelection}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.ForAcceptance}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.ForDispatch}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.DispatchProblem}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Operator}_${AuctionStatuses.Finished}`]: [
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Pending}`]: [
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'Από Αρχείο',
    'Photos',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Active}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.ForSelection}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.ForAcceptance}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.ForDispatch}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.DispatchProblem}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Finished}`]: [
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.Active}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.Pending}`]: [
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.ForSelection}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.ForAcceptance}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.ForDispatch}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.DispatchProblem}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Insurance}_${AuctionStatuses.Finished}`]: [
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.Active}`]: [
    'Φωτογραφίες',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Merchant}_Participate`]: [
    'Φωτογραφίες',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.ForAcceptance}`]: [
    'Φωτογραφίες',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.ForDispatch}`]: [
    'Φωτογραφίες',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.DispatchProblem}`]: [
    'Φωτογραφίες',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Merchant}_${AuctionStatuses.Finished}`]: [
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Expert}_${AuctionStatuses.Finished}`]: [
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Expert}_${AuctionStatuses.Active}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Expert}_${AuctionStatuses.Pending}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],

  [`${PartyTypes.Expert}_${AuctionStatuses.ForSelection}`]: [
    'Φωτογραφίες',
    'Αρ.Φακέλου',
    'Πινακίδα',
    'Ασφαλιστική',
    'Χαρακτηριστικά',
    'Νομός',
    'EndDate',
    'Folder',
  ],
};

export default RoleStatusColumnsDefs;
